// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-only Favorites + Providers row (Lotus .casino-lobby). Desktop: hidden. */
.lotus-casino-lobby-nav {
  display: none;
}

@media (max-width: 1119px) {
  .lotus-casino-lobby-nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    background: transparent;
  }

  .lotus-casino-lobby-nav__title {
    display: none;
  }

  .lotus-casino-lobby-nav__buttons {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .lotus-casino-lobby-nav__item {
    display: inline-flex;
    align-items: center;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    color: #ffffff;
    font-family: "Lato", sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .lotus-casino-lobby-nav__item:focus,
  .lotus-casino-lobby-nav__item:focus-visible,
  .lotus-casino-lobby-nav__item:active {
    outline: none;
  }

  .lotus-casino-lobby-nav__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .lotus-casino-lobby-nav__icon svg {
    width: 20px;
    height: 20px;
    display: block;
  }

  .lotus-casino-lobby-nav__item .icon-filter {
    font-size: 20px;
    line-height: 1;
    margin-right: 8px;
    color: #ffffff;
  }

  .lotus-casino-lobby-nav__separator {
    display: inline-block;
    width: 1px;
    height: 24px;
    margin: 0 8px;
    background: #494d52;
    flex-shrink: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoLobby/LotusCasinoLobbyNav.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,wCAAwC;EAC1C;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;AACF","sourcesContent":["/* Mobile-only Favorites + Providers row (Lotus .casino-lobby). Desktop: hidden. */\n.lotus-casino-lobby-nav {\n  display: none;\n}\n\n@media (max-width: 1119px) {\n  .lotus-casino-lobby-nav {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    padding: 6px 12px;\n    box-sizing: border-box;\n    background: transparent;\n  }\n\n  .lotus-casino-lobby-nav__title {\n    display: none;\n  }\n\n  .lotus-casino-lobby-nav__buttons {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n  }\n\n  .lotus-casino-lobby-nav__item {\n    display: inline-flex;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    border: none;\n    background: transparent;\n    color: #ffffff;\n    font-family: \"Lato\", sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .lotus-casino-lobby-nav__item:focus,\n  .lotus-casino-lobby-nav__item:focus-visible,\n  .lotus-casino-lobby-nav__item:active {\n    outline: none;\n  }\n\n  .lotus-casino-lobby-nav__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    flex-shrink: 0;\n  }\n\n  .lotus-casino-lobby-nav__icon svg {\n    width: 20px;\n    height: 20px;\n    display: block;\n  }\n\n  .lotus-casino-lobby-nav__item .icon-filter {\n    font-size: 20px;\n    line-height: 1;\n    margin-right: 8px;\n    color: #ffffff;\n  }\n\n  .lotus-casino-lobby-nav__separator {\n    display: inline-block;\n    width: 1px;\n    height: 24px;\n    margin: 0 8px;\n    background: #494d52;\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
